module.exports = __webpack_public_path__ + "static/media/step-2.7f2e9828.webp";